/* eslint-disable complexity */
import React from 'react';

import {
  Table,
  createColumnWidths,
  createColumnsWidths,
} from '@qality/common-components/src/atoms/Table';
import { TestCycle } from '@qality/common-model';

import { TestCyclesOverviewRowGadget } from './TestCyclesOverviewTableGadget.row';

type Columns =
  | 'testCycle'
  | 'project'
  | 'version'
  | 'status'
  | 'created'
  | 'dueDate'
  | 'actions';

const ColumnsWidths = createColumnsWidths<Columns>({
  testCycle: createColumnWidths('auto', '100px'),
  project: createColumnWidths('auto', '100px'),
  version: createColumnWidths(),
  status: createColumnWidths(),
  created: createColumnWidths(),
  dueDate: createColumnWidths(),
  actions: createColumnWidths(),
});

export type TestCyclesOverviewTableViewProps = {
  testCycles: TestCycle[];
  showProject: boolean;
  showStatus: boolean;
  handleOverviewAction: (testCycleId) => void;
};

export const TestCyclesOverviewTableGadgetView: React.FC<TestCyclesOverviewTableViewProps> =
  (props: TestCyclesOverviewTableViewProps) => {
    const { testCycles, showProject, showStatus, handleOverviewAction } = props;

    return (
      <Table data-testid='TestCyclesOverviewTableView-Table' addStickyHeader>
        <Table.Head>
          <Table.Tr>
            <Table.Th widths={ColumnsWidths.testCycle}>Test Cycle</Table.Th>
            {showProject && (
              <Table.Th widths={ColumnsWidths.project}>Project</Table.Th>
            )}
            <Table.Th widths={ColumnsWidths.version}>Version</Table.Th>
            {showStatus && (
              <Table.Th widths={ColumnsWidths.status}>Status</Table.Th>
            )}
            <Table.Th widths={ColumnsWidths.created}>Created</Table.Th>
            <Table.Th widths={ColumnsWidths.dueDate}>Due date</Table.Th>
            <Table.Th widths={ColumnsWidths.actions} />
          </Table.Tr>
        </Table.Head>

        <Table.Body>
          {testCycles.map((testCycle, index) => {
            return (
              <TestCyclesOverviewRowGadget
                key={`${testCycle.id}-${index}`}
                testCycle={testCycle}
                handleOverviewAction={handleOverviewAction}
                showProject={showProject}
                showStatus={showStatus}
              />
            );
          })}
        </Table.Body>
      </Table>
    );
  };
